"use strict";
/*!
 * This file is part of the IVMS Online.
 *
 * @copyright 2020, 2022 - 2026 © by Rafał Wrzeszcz - Wrzasq.pl.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@aws-amplify/ui-react/styles.css");
require("@fontsource/roboto/300.css");
require("@fontsource/roboto/400.css");
require("@fontsource/roboto/500.css");
require("@fontsource/roboto/700.css");
const ui_react_1 = require("@aws-amplify/ui-react");
const x_date_pickers_1 = require("@mui/x-date-pickers");
const AdapterMoment_1 = require("@mui/x-date-pickers/AdapterMoment");
const aws_amplify_1 = require("aws-amplify");
const auth_1 = require("aws-amplify/auth");
const React = require("react");
const client_1 = require("react-dom/client");
const react_router_1 = require("react-router");
const Application_1 = require("./app/Application");
const VesselDashboard_1 = require("./vessels/views/VesselDashboard");
const VesselsList_1 = require("./vessels/views/VesselsList");
const VesselLiveView_1 = require("./vessels/views/VesselLiveView");
const VesselStatusPage_1 = require("./vessels/views/VesselStatusPage");
aws_amplify_1.Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: process.env.COGNITO_POOL_ID || "",
            userPoolClientId: process.env.COGNITO_CLIENT_ID || "",
        },
    },
    API: {
        GraphQL: {
            endpoint: process.env.API_URL || "",
            defaultAuthMode: "userPool",
        },
    },
}, {
    API: {
        GraphQL: {
            headers: () => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b;
                const session = yield (0, auth_1.fetchAuthSession)();
                const token = (_b = (_a = session.tokens) === null || _a === void 0 ? void 0 : _a.idToken) === null || _b === void 0 ? void 0 : _b.toString();
                return {
                    Authorization: token,
                };
            }),
        },
    },
});
document.addEventListener("DOMContentLoaded", () => {
    const container = document.getElementById("app");
    const router = (0, react_router_1.createBrowserRouter)([
        {
            Component: Application_1.Application,
            children: [
                {
                    path: "",
                    Component: VesselsList_1.VesselsList,
                },
                {
                    path: "vessels/:vesselId",
                    Component: VesselStatusPage_1.VesselStatusPage,
                },
                {
                    path: "vessels/:vesselId/live",
                    Component: VesselLiveView_1.VesselLiveView,
                },
                {
                    path: "vessels/:vesselId/dashboards/:embedKey",
                    Component: VesselDashboard_1.VesselDashboard,
                },
            ],
        }
    ]);
    const theme = {
        name: "dark",
        overrides: [ui_react_1.defaultDarkModeOverride],
    };
    if (container) {
        (0, client_1.createRoot)(container)
            .render(React.createElement(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterMoment_1.AdapterMoment },
            React.createElement(ui_react_1.ThemeProvider, { theme: theme, colorMode: "dark" },
                React.createElement(react_router_1.RouterProvider, { router: router }))));
    }
});
